import React from 'react';
import createReactContext from '../context';
var context = createReactContext({}); // eslint-disable-next-line

export var Provider = context.Provider;

var consumer = function consumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, null, function (value) {
        var mp = Object.assign({}, props, value && props.absolute && props.zIndex === undefined && {
          zIndex: 1051
        });
        return (
          /*#__PURE__*/
          React.createElement(Origin, mp)
        );
      })
    );
  };
};

export default consumer;